import { buildDutyMenuGermanItems } from "@/app/ui/navigation/dutyMenuGerman";
import { buildDutyMenuAustralianItems } from "@/app/ui/navigation/dutyMenuAustralian";
import { buildDutyMenuSouthAfricanItems } from "@/app/ui/navigation/dutyMenuSouthAfrican";
import { buildDutyMenuUkItems } from "@/app/ui/navigation/dutyMenuUk";
import { buildDutyMenuSwedishItems } from "@/app/ui/navigation/dutyMenuSwedish";
import { buildDutyMenuUsItems } from "@/app/ui/navigation/dutyMenuUs";
import type { MenuItem } from "@/app/ui/navigation/types";
import { buildDutyMenuEireItems } from "@/app/ui/navigation/dutyMenuEire";
import { buildDutyMenuNzItems } from "@/app/ui/navigation/dutyMenuNz";

export const buildDutyMenuItems: () => MenuItem[] = () => [
  ...buildDutyMenuUkItems(),
  ...buildDutyMenuGermanItems(),
  ...buildDutyMenuAustralianItems(),
  ...buildDutyMenuSouthAfricanItems(),
  ...buildDutyMenuSwedishItems(),
  ...buildDutyMenuUsItems(),
  ...buildDutyMenuEireItems(),
  ...buildDutyMenuNzItems(),
];
